import { bcbs_config_category } from "model/CRM";
import { IBenefit, IGroupConfigurationConfig } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class UpdateBenefitCategoryPropertiesTransformer extends BaseJsonTransformer {
    readonly categoryLookup = new Map<string, bcbs_config_category>();

    constructor(release: IGroupConfigurationConfig) {
        super();

        for (let category of release.categories) {
            this.categoryLookup.set(category.bcbs_config_categoryid!, category);
        }
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        let newCategory = this.categoryLookup.get(benefit.bcbs_config_categoryid!);
        if (newCategory) {
            // benefit = { ...benefit, ...newCategory };
            benefit.bcbs_helptext = newCategory.bcbs_helptext;
            benefit.bcbs_name = newCategory.bcbs_name;
            benefit.bcbs_sortorder = newCategory.bcbs_sortorder;
            benefit.bcbs_isenablenonstandard = newCategory.bcbs_isenablenonstandard;
            benefit.bcbs_isfundingtypeenabled = newCategory.bcbs_isfundingtypeenabled;
        }
    }
}
